import React from 'react';

import { observer, inject } from 'mobx-react';
import { FeedbackStyle } from '@/types/components/Feedback';

import bubbleLeftImage from '@/assets/img/bubble_left@4x.png';
import bubbleRightImage from '@/assets/img/bubble_right@4x.png';
import bankBubbleRightImage from '@/assets/img/bank_bubble_right@4x.png';
import Reload from '@/assets/img/reload.svg';
const FeedbackRight = React.lazy(() => import(/* webpackChunkName: 'lazyLoadDialogue' */ '@/components/FeedbackRight'));
const FeedbackBottom = React.lazy(() => import(/* webpackChunkName: 'lazyLoadDialogue' */ '@/components/FeedbackBottom'));
import clsx from 'classnames';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { updateDialogueOuterData } from '@/utils/sessionUtils';
import { reportReplyTimeCost } from '@/utils/replyTimeCostReport';

import './style.scss';
import { isBank } from '@/config/core';

const PREFIX = 'dialogue-container';

@inject(getChildInject('userStore', 'initStore'))
@observer
export default class Dialogue extends React.PureComponent {
  static defaultProps = {
    // passed props
    from: 'user',
    renderStyle: 'bubble',
    messageDocQATipText: '',
    isDisabled: false,
    hideBubbleAngle: false,
    hideDialogue: false,
    minimizeDialogue: false,
    haveMinWidth: false,
    // render props
    children: null,
    extraChildren: null,
    // stores
    userStore: {},
    initStore: {},
    showMaxWidth: false,
    dontUseMaxWidth: false,
    useFullMaxWidth: false,
    showAnimation: false,
    showReloadIcon: false,
    onlyComponent: false,
    onReloadClick: () => { },
  };

  constructor(props) {
    super(props);
    this.state = { initialShowAnimation: props.showAnimation };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ initialShowAnimation: false });
      updateDialogueOuterData({ showAnimation: false }, this.props.listPos);
    }, 1000);
    reportReplyTimeCost(this.props);
  }

  render() {
    const {
      from,
      renderStyle,
      feedbackInfo,
      children,
      extraChildren,
      isDisabled,
      hideBubbleAngle,
      showMaxWidth,
      dontUseMaxWidth,
      useFullMaxWidth,
      hideDialogue,
      minimizeDialogue,
      showReloadIcon,
      onReloadClick,
      highZIndex,
      haveMinWidth,
      onlyComponent,
      isMinimiseCategorySmallerTab,
      messageDocQATipText,
      alignCenter,
    } = this.props;

    const isLeft = from === 'bot' || from === 'agent';

    let basicClassName = 'left-dialogue';
    if (from === 'user') {
      basicClassName = 'right-dialogue';
    }

    const bubbleClassName = `bubble${renderStyle === 'reversedBubble' ? ' reversed' : ''}${hideBubbleAngle ? ' hide-bubble-angle' : ''}`;

    const bubbleAngleElement = isLeft ? (
      <img src={bubbleLeftImage} />
    ) : isBank() ? (
      <img src={bankBubbleRightImage} />
    ) : (
      <img src={bubbleRightImage} />
    );

    const messageDocQATipTextElement = () => {
      if (messageDocQATipText) {
        if (typeof messageDocQATipText === 'string') {
          return <div className="message-doc-qa-tip-text">{messageDocQATipText}</div>;
        } else if (messageDocQATipText?.length) {
          return <div>
            {messageDocQATipText.map((text) => <div className="message-doc-qa-tip-text">{text}</div>)}
          </div>;
        }
      }
      return null;
    };

    // OrderList类型的消息的order列表，session过期的会全部隐藏
    if (isDisabled) {
      return null;
    }

    // 只展示 组件 不包裹 dialogue
    if (onlyComponent) {
      return children;
    }

    return (
      <div className={
        clsx(
          `${PREFIX} ${basicClassName}`,
          'chatbot-dialogue',
          {
            'hide-dialogue': hideDialogue,
            'minimize-dialogue': minimizeDialogue,
            'card-dialogue': haveMinWidth,
            'first-dialogue': !hideBubbleAngle,
            'show-animation': this.state.initialShowAnimation,
            'minimise-category-smaller-tab': isMinimiseCategorySmallerTab,
            'align-center': alignCenter,
          },
        )
      }>
        <div className={clsx('content-container', {
          'fill-bubble': showMaxWidth,
          'fill-extra': useFullMaxWidth,
          'no-max-width': dontUseMaxWidth,
          'dialogue-content-hight-z-index': highZIndex,
          'have-min-width': haveMinWidth,
        })}>
          {renderStyle === 'bubble' || renderStyle === 'reversedBubble' ? (
            <div className={bubbleClassName}>
              {hideBubbleAngle ? null : <div className="bubble-angle">{bubbleAngleElement}</div>}
              <div className="content">{children}</div>
              {
                // feedback
                feedbackInfo?.style === FeedbackStyle.bottom
                  ? <React.Suspense fallback={null}>
                    <FeedbackBottom {...feedbackInfo} />
                  </React.Suspense>
                  : null
              }
            </div>
          ) : null}
          {renderStyle === 'text' ? <div className="text">{children}</div> : null}
          <div className="extra">{extraChildren}</div>
          {messageDocQATipTextElement()}
        </div>
        {
          showReloadIcon
            ? <div className="dialogue-reload" onClick={onReloadClick}><img src={Reload} /></div>
            : feedbackInfo?.style === FeedbackStyle.right
              ? <React.Suspense fallback={null}>
                <FeedbackRight {...feedbackInfo} />
              </React.Suspense>
              : null
        }
      </div>
    );
  }
}
